import { useEffect } from "react";
import { IAudioHandles } from "../providers/AudioProvider/handleTypes";
import { IAudioState, LocalStorageKeys } from "../providers/AudioProvider/types";

interface IUseHandleSavedTrackPlay {
    handles: IAudioHandles;
    state: IAudioState;
}

export const useHandleSavedTrackPlay = ({ handles, state }: IUseHandleSavedTrackPlay) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if ((event.metaKey || event.ctrlKey) && event.key === "u") {
                event.preventDefault(); // чтобы не открывалось новое окно браузера
                if (
                    !state.playing &&
                    state.changedAudioTrackIds &&
                    state.changedAudioTrackIds.length > 0
                ) {
                    handles.setPlaySavedTrack(true);
                }
            }

            if ((event.metaKey || event.ctrlKey) && event.key === "i") {
                event.preventDefault(); // чтобы не открывалось новое окно браузера
                console.log("Cmd/Ctrl + i нажато!");
                const pausedTime = localStorage.getItem(LocalStorageKeys.pausedTime);
                if (pausedTime && !state.playing) {
                    handles.setPlaying(true);
                    handles.setStartPlaying(true);
                    handles.setPlayingFragment(null);
                    handles.setPlayOriginalStart(+pausedTime);
                    handles.setPlaybackTime(+pausedTime);
                }
            }
        };

        document.addEventListener("keydown", handleKeyDown, true);

        return () => {
            document.removeEventListener("keydown", handleKeyDown, true);
        };
    }, [state.playing, state.changedAudioTrackIds]);
};
